import { store } from "lib/store";

export const alertWithWithdrawV2 = () => {
  store.dispatch({
    type: "ACTION_WITHDRAW_V2_IS_OPEN_MODAL",
  });
};

export const alertWithWithdrawV2Close = () => {
  store.dispatch({
    type: "ACTION_WITHDRAW_V2_IS_CLOSE_MODAL",
  });
};
